import React, { useState, createRef, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useScreenshot, createFileName } from "use-react-screenshot";
import CropEasy from "./Components/crop/CropEasy";
import { BsFillCloudUploadFill } from "react-icons/bs";
import Loader from "./Components/Loader";
import { useReactToPrint } from "react-to-print";
import "./assets/style/index.css";
import Post from "./Components/PostSVG/Post";

function App() {
  const [state, setState] = React.useState({ name: "", selectedOption: "EM" });
  const [isLoading, setIsLoading] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const ref = createRef(null);
  const [fileMain, setFileMain] = React.useState(null);
  const [fileSide, setFileSide] = React.useState(null);
  const [photoURLSide, setPhotoURLSide] = React.useState();
  const [photoURLMain, setPhotoURLMain] = React.useState();

  const [photoMain, setPhotoMain] = React.useState();
  const [photoSide, setPhotoSide] = React.useState();
  const [type, setType] = useState("");
  const [openCrop, setOpenCrop] = React.useState(false);
  const [display, setDisplay] = React.useState("block");
  const [isMobileScreen, setIsMobileScreen] = React.useState(false);
  const [screenshotCount, setScreenshotCount] = useState(0);
  const [showHiddenDiv, setShowHiddenDiv] = useState(false);

  const handleMainChange = async (e) => {
    const file = e.target.files[0];
    setType("Main");
    if (file) {
      setOpenCrop(true);
      setFileMain(file);
      setPhotoURLMain(URL.createObjectURL(file));
    }
  };

  const [image, takeScreenShot] = useScreenshot({
    type: "image/png",
    quality: 10,
  });

  const downloadScreenshot = async () => {
    setIsLoading(true);
    setShowHiddenDiv(true);
    setScreenshotCount((prev) => prev + 1);
    await takeScreenShot(ref.current)
      .then((image) => {
        if (screenshotCount === 1) {
          const link = document.createElement("a");
          link.href = image;
          link.download = "DishaCampaignPost.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setScreenshotCount(0);
          setShowHiddenDiv(false);
        }
      })
      .catch((error) => {
        console.error("Error while taking screenshot:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (screenshotCount === 1 && showHiddenDiv) {
      downloadScreenshot();
    }
  }, [screenshotCount, showHiddenDiv]);

  let isMobile = window.innerWidth < 500;

  useEffect(() => {
    if (isMobile) {
      setIsMobileScreen(true);
    }
  }, [isMobile]);

  const convertSvgToPng = async () => {
    try {
      const response = await fetch("/DishaCampaignPost.svg");
      const svgText = await response.text();

      const svgBase64 = "data:image/svg+xml;base64," + btoa(svgText);

      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = svgBase64;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        const base64Png = canvas.toDataURL("image/png");
        console.log("✅ Base64 PNG:", base64Png);
      };
    } catch (error) {
      console.error("❌ Error converting SVG to PNG:", error);
    }
  };

  useEffect(() => {
    convertSvgToPng();
  }, []);

  return (
    <>
      {openCrop ? (
        <CropEasy
          {...{
            photoURLSide,
            photoURLMain,
            setOpenCrop,
            setPhotoURLSide,
            setPhotoURLMain,
            setFileSide,
            setFileMain,
            setPhotoMain,
            setPhotoSide,
            type,
          }}
        />
      ) : (
        <div className="App">
          {loading && <Loader />}
          <div className="nav w-100 header-sticky">
            <h2 className="nav_head">Webito Infotech Invitation</h2>
          </div>
          <Container style={{ backgroundColor: "white" }}>
            <Row>
              <Col className="col-12 col-md-6 form_main mb-5">
                <Form className="form_data">
                  <Form.Group className="mt-3 form_C form_name">
                    <Form.Label>First Name:</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setState({
                          ...state,
                          firstName: e.target.value?.toUpperCase(),
                        });
                      }}
                      name="firstName"
                      value={state?.firstName}
                      placeholder="Enter the first name"
                    />
                  </Form.Group>
                  <Form.Group className="mt-3 form_C form_upload">
                    <Form.Control
                      className="d-none"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      id="myfile"
                      name="myfile"
                      onChange={handleMainChange}
                    />
                    <label for="myfile" className="file_upload">
                      <h1>Upload Profile Pic</h1>
                      <div>
                        <p>
                          Click on the upload icon to upload profile pic. You
                          can repeat this step to choose another profile pic.
                        </p>
                        <div className="box_icon">
                          <BsFillCloudUploadFill />
                        </div>
                      </div>
                    </label>
                  </Form.Group>
                  <Button
                    type="button"
                    className="mt-3 form_button"
                    style={{
                      backgroundColor: "#0c6566",
                      borderColor: "#0c6566",
                    }}
                    onClick={() => downloadScreenshot()}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading......" : "Download"}
                  </Button>
                </Form>
              </Col>
            </Row>
            <Col
              className="col-10 d-flex col-md-10"
              style={{
                marginTop: isMobileScreen ? "180px" : "0px",
              }}
            >
              <div ref={ref}>
                <Post
                  fileMain={photoMain}
                  fileSide={photoSide}
                  firstName={state.firstName}
                  companyName={state.companyName}
                />
              </div>
            </Col>
          </Container>
        </div>
      )}
    </>
  );
}

export default App;
